module.exports = __webpack_public_path__ + "static/media/play.aec3ad71.svg";